export const dynamicHTMLUpdate = ({ rootDocData }) => {
  try {
    // client related fields
    const dynamicClients = document.querySelectorAll('[data-signature-block^="DYNAMIC_CLIENT"]:not([data-signature-block^="DYNAMIC_CLIENT_REVERSE"])');
    // Dynamic clients Initials
    const dynamicClientsInitials = document.querySelectorAll(`[data-initial-box="DYNAMIC_CLIENT"]`);
    const dynamicClientEditIcons = document.querySelectorAll("[data-client-edit-icon]");
    const dynamicClientList = document.querySelectorAll("[data-client-list], [data-client-list-A], [data-client-list-B]");
    const dynamicClientFirmList = document.querySelectorAll("[data-client-firm-list], [data-client-firm-list-A], [data-client-firm-list-B]");
    const dynamicClientEmailList = document.querySelectorAll("[data-client-email-list], [data-client-email-list-A], [data-client-email-list-B]");
    const dynamicClientPhoneList = document.querySelectorAll("[data-client-phone-list], [data-client-phone-list-A], [data-client-phone-list-B]");
    // client dynamic reverse
    const dynamicReverseClients = document.querySelectorAll('[data-signature-block^="DYNAMIC_CLIENT_REVERSE"]');
    // Dynamic reverse initial field
    const dynamicReverseClientsInitials = document.querySelectorAll(`[data-initial-box="DYNAMIC_CLIENT_REVERSE"]`);
    //  Agents related fields
    const dynamicAgents = document.querySelectorAll('[data-signature-block^="DYNAMIC_AGENT"]:not([data-signature-block^="DYNAMIC_AGENT_REVERSE"])');
    const dynamicAgentsReverse = document.querySelectorAll('[data-signature-block^="DYNAMIC_AGENT_REVERSE"]');
    const dynamicBrokerButton = document.querySelectorAll("[data-add-coDynamicBroker-btn]");
    const dynamicBrokerButtonReverse = document.querySelectorAll("[data-add-coDynamicBroker-btn-reverse]");
    const dynamicBrokerList = document.querySelectorAll("[data-dynamic-agent-list], [data-dynamic-agent-list-A], [data-dynamic-agent-list-B]");
    const dynamicBrokerFirmList = document.querySelectorAll("[data-dynamic-agent-firm-list]");

    dynamicClients?.forEach((element) => {
      const signatureBlockAttr = element?.dataset?.signatureBlock;
      const suffix = signatureBlockAttr?.split("_")?.[2];
      const preSuffixFull = signatureBlockAttr?.split("-")?.[1];
      const preSuffix = preSuffixFull?.match(/[A-Za-z]+/)?.[0];
      // console.log("element", element);
      let signatureBlock = rootDocData?.RTDInitiator;
      if (suffix && preSuffix) {
        signatureBlock += `-${preSuffix}_${suffix}`;
      } else {
        if (preSuffix) {
          signatureBlock += "-" + preSuffix;
        }
        if (suffix) {
          signatureBlock += "_" + suffix;
        }
      }
      element.dataset.signatureBlock = signatureBlock;
    });

    dynamicReverseClients.forEach((element) => {
      const normalized = (element.dataset.signatureBlock || "")?.replace(/_?REVERSE/, "");
      const suffix = normalized.split("_")?.[2];
      const preSuffixFull = normalized.split("-")?.[1];
      const preSuffix = preSuffixFull?.match(/[A-Za-z]+/)?.[0];
      let signatureBlock = rootDocData?.RTDInitiator === "BUYER" ? "SELLER" : "BUYER";

      if (suffix && preSuffix) {
        signatureBlock += `-${preSuffix}_${suffix}`;
      } else {
        if (preSuffix) signatureBlock += "-" + preSuffix;
        if (suffix) signatureBlock += "_" + suffix;
      }

      element.dataset.signatureBlock = signatureBlock;
    });

    dynamicClientsInitials?.forEach((element) => {
      let finalClientType = rootDocData?.RTDInitiator === "BUYER" ? "BUYERS" : "SELLERS";
      element.dataset.initialBox = finalClientType;
    });

    dynamicReverseClientsInitials?.forEach((element) => {
      let finalClientType = rootDocData?.RTDInitiator === "BUYER" ? "SELLERS" : "BUYERS";
      element.dataset.initialBox = finalClientType;
    });

    dynamicClientList?.forEach((element) => {
      const originalAttr = Array.from(element.attributes).find((attr) => attr.name.startsWith("data-client-list"));
      if (!originalAttr) return;
      const suffix = originalAttr.name.replace("data-client-list", "");
      element.removeAttribute(originalAttr.name);
      const newAttrName = rootDocData?.RTDInitiator === "BUYER" ? `data-buyers-list${suffix}` : `data-sellers-list${suffix}`;
      element.setAttribute(newAttrName, "");
      element.setAttribute("name", rootDocData?.RTDInitiator === "BUYER" ? `BuyerList${suffix}` : `SellerList${suffix}`);
    });

    dynamicClientFirmList?.forEach((element) => {
      const originalAttr = Array.from(element.attributes).find((attr) => attr.name.startsWith("data-client-firm-list"));
      if (!originalAttr) return;
      const suffix = originalAttr.name.replace("data-client-firm-list", "");
      element.removeAttribute(originalAttr.name);
      const newAttrName = rootDocData?.RTDInitiator === "BUYER" ? `data-buyers-firm-list${suffix}` : `data-sellers-firm-list${suffix}`;
      element.setAttribute(newAttrName, "");
      element.setAttribute("name", rootDocData?.RTDInitiator === "BUYER" ? `BuyerFirmList${suffix}` : `SellerFirmList${suffix}`);
    });

    dynamicClientEmailList?.forEach((element) => {
      const originalAttr = Array.from(element.attributes).find((attr) => attr.name.startsWith("data-client-email-list"));
      if (!originalAttr) return;
      const suffix = originalAttr.name.replace("data-client-email-list", "");
      element.removeAttribute(originalAttr.name);
      const newAttrName = rootDocData?.RTDInitiator === "BUYER" ? `data-buyers-email-list${suffix}` : `data-sellers-email-list${suffix}`;
      element.setAttribute(newAttrName, "");
      element.setAttribute("name", rootDocData?.RTDInitiator === "BUYER" ? `BuyerEmailList${suffix}` : `SellerEmailList${suffix}`);
    });
    dynamicClientPhoneList?.forEach((element) => {
      const originalAttr = Array.from(element.attributes).find((attr) => attr.name.startsWith("data-client-phone-list"));
      if (!originalAttr) return;
      const suffix = originalAttr.name.replace("data-client-phone-list", "");
      element.removeAttribute(originalAttr.name);
      const newAttrName = rootDocData?.RTDInitiator === "BUYER" ? `data-buyers-phone-list${suffix}` : `data-sellers-phone-list${suffix}`;
      element.setAttribute(newAttrName, "");
      element.setAttribute("name", rootDocData?.RTDInitiator === "BUYER" ? `BuyerPhoneList${suffix}` : `SellerPhoneList${suffix}`);
    });

    dynamicClientEditIcons?.forEach((element) => {
      element.removeAttribute("data-client-edit-icon");
      element.setAttribute(rootDocData?.RTDInitiator === "BUYER" ? "data-buyer-edit-icon" : "data-seller-edit-icon", "");
      const parentDiv = element.closest("div");
      if (rootDocData?.contractType !== "DC_CAL" && parentDiv && !element.hasAttribute("data-edit-modal-title")) {
        parentDiv.textContent = rootDocData?.RTDInitiator === "BUYER" ? "Buyer(s)" : "Seller(s)";
        parentDiv.appendChild(element);
      }
    });

    // updating everything for  Brokers
    if (dynamicBrokerButton.length) {
      dynamicBrokerButton.forEach((element) => {
        element.removeAttribute("data-add-coDynamicBroker-btn");
        element.setAttribute(rootDocData?.RTDInitiator === "BUYER" ? "data-add-coBuyerBroker-btn" : "data-add-coSellerBroker-btn", "");
      });
    }

    if (dynamicBrokerButtonReverse.length) {
      dynamicBrokerButtonReverse.forEach((element) => {
        element.removeAttribute("data-add-coDynamicBroker-btn-reverse");
        element.setAttribute(rootDocData?.RTDInitiator === "SELLER" ? "data-add-coBuyerBroker-btn" : "data-add-coSellerBroker-btn", "");
        element.innerHTML = "Add Co Broker Working With " + (rootDocData?.RTDInitiator === "SELLER" ? "Buyer" : "Seller");
      });
    }

    if (dynamicBrokerList) {
      dynamicBrokerList.forEach((element) => {
        const originalAttr = Array.from(element.attributes).find((attr) => attr.name.startsWith("data-dynamic-agent-list"));
        if (!originalAttr) return;
        const suffix = originalAttr.name.replace("data-dynamic-agent-list", "");
        element.removeAttribute(originalAttr.name);
        const newAttrName = rootDocData?.RTDInitiator === "BUYER" ? `data-buyer-brokers-list${suffix}` : `data-seller-brokers-list${suffix}`;
        element.setAttribute(newAttrName, "");
        element.setAttribute("name", rootDocData?.RTDInitiator === "BUYER" ? `BuyerBrokersList${suffix}` : `SellerBrokersList${suffix}`);
      });
    }

    if (dynamicBrokerFirmList) {
      dynamicBrokerFirmList.forEach((element) => {
        const originalAttr = Array.from(element.attributes).find((attr) => attr.name.startsWith("data-dynamic-agent-firm-list"));
        if (!originalAttr) return;
        const suffix = originalAttr.name.replace("data-dynamic-agent-firm-list", "");
        element.removeAttribute(originalAttr.name);
        const newAttrName = rootDocData?.RTDInitiator === "BUYER" ? `data-buyer-brokers-firm-list${suffix}` : `data-seller-brokers-firm-list${suffix}`;
        element.setAttribute(newAttrName, "");
        element.setAttribute("name", rootDocData?.RTDInitiator === "BUYER" ? `BuyerBrokersFirmList${suffix}` : `SellerBrokersFirmList${suffix}`);
      });
    }

    const dynamicAgentsIds = document.getElementById("dynamicAgentFields");
    if (dynamicAgentsIds) {
      dynamicAgentsIds.id = rootDocData?.RTDInitiator === "BUYER" ? "buyerAgentFields" : "sellerAgentFields";
    }
    const dynamicAgentsIdsReverse = document.getElementById("dynamicAgentFields_Reverse");
    if (dynamicAgentsIdsReverse) {
      dynamicAgentsIdsReverse.setAttribute("id", rootDocData?.RTDInitiator === "SELLER" ? "buyerAgentFields" : "sellerAgentFields"); 
    }
    dynamicAgents.forEach((element) => {
      const suffix = element?.dataset?.signatureBlock?.split("_")?.[2];
      let signatureBlock = rootDocData?.RTDInitiator === "BUYER" ? "CO_BUYER_BROKER" : "CO_SELLER_BROKER";
      const preSuffix = element.dataset.signatureBlock?.split("-")?.[1];
      if (preSuffix) {
        signatureBlock += "-" + preSuffix;
      }
      if (suffix) {
        signatureBlock += "_" + suffix;
      }
      element.dataset.signatureBlock = signatureBlock;
    });
    // console.log("dynamicAgentsReverse", dynamicAgentsReverse);
    dynamicAgentsReverse.forEach((element) => {
      const currentBlock = element.dataset.signatureBlock?.replace(/_?REVERSE/, "") || "";
      const suffix = currentBlock.split("_")?.[2];
      const preSuffix = currentBlock.split("-")?.[1];
      let signatureBlock = rootDocData?.RTDInitiator === "BUYER" ? "CO_SELLER_BROKER" : "CO_BUYER_BROKER";
      if (preSuffix) {
        signatureBlock += "-" + preSuffix;
      }
      if (suffix) {
        signatureBlock += "_" + suffix;
      }
      element.dataset.signatureBlock = signatureBlock;
    });
  } catch (error) {
    console.error(error);
  }
};
